import { Link } from "react-router-dom";

// Detects case citations like "Saenz v. Roe" or "United States v. Wong Kim Ark"
// and renders them as links into the Case Law search.
const CASE_RE = /([A-Z][A-Za-z.'&-]+(?:\s+[A-Z][A-Za-z.'&-]+)*\s+v\.\s+[A-Z][A-Za-z.'&-]+(?:\s+[A-Za-z.'&-]+){0,5})/g;

export default function CaseText({ text, className = "" }) {
  if (!text) return null;
  const parts = [];
  let last = 0;
  let m;
  let key = 0;
  CASE_RE.lastIndex = 0;
  while ((m = CASE_RE.exec(text)) !== null) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    const name = m[1].trim().replace(/[.,;]$/, "");
    parts.push(
      <Link
        key={`c-${key++}`}
        to={`/caselaw?q=${encodeURIComponent(name)}`}
        data-testid="inline-case-link"
        className="text-primary underline decoration-primary/40 underline-offset-2 hover:decoration-primary"
      >
        {m[1]}
      </Link>
    );
    last = m.index + m[1].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return <span className={className}>{parts}</span>;
}
